import {
  Home,
  Tariffs,
  Packages,
  TariffsTablet,
  PackagesTablet,
  HomeTablet,
  SimIcon,
} from '@/icons/index';
import SmsNew from '@/components/SvgComponents/SmsNew';
import InternetNew from '@/components/SvgComponents/InternetNew';
import CallNew from '@/components/SvgComponents/CallNew';

export const iconMapping = {
  WHATSAPP: 'whatsapp',
  SOCIAL_MEDIA: 'social',
  TELEGRAM: 'telegram',
};

export const userNumbers = [
  {
    id: 162,
    type: 'PHONE',
    subType: 'CORPORATE_PART_PAY',
    status: 'ACTIVE',
    phone: {
      number: '555904978',
      type: 'POSTPAID',
      numberName: null,
    },
    balance: 119.7,
    pendingBalance: null,
    subscription: {
      offeringId: '995806196',
      name: 'AZRC Employee',
    },
    canGetPackage: false,
    canGetTariff: false,
    eligibleForBonus: false,
    isPrimary: true,
    numberId: 22,
    numberStatus: 'ACTIVE',
  },
  {
    id: 427887,
    type: 'PHONE',
    subType: null,
    status: 'ACTIVE',
    phone: {
      number: '559317228',
      type: 'PREPAID',
      numberName: null,
    },
    balance: 0,
    pendingBalance: null,
    subscription: {
      offeringId: '0',
      name: '',
    },
    canGetPackage: false,
    canGetTariff: false,
    eligibleForBonus: false,
    isPrimary: false,
    numberId: 85470,
    numberStatus: 'BLOCK_1_WAY',
  },
  {
    id: 427887,
    type: 'PHONE',
    subType: null,
    status: 'BLOCK_2_WAY',
    phone: {
      number: '559317228',
      type: 'PREPAID',
      numberName: null,
    },
    balance: 0,
    pendingBalance: null,
    subscription: {
      offeringId: '0',
      name: '',
    },
    canGetPackage: false,
    canGetTariff: false,
    eligibleForBonus: false,
    isPrimary: false,
    numberId: 85470,
    numberStatus: 'BLOCK_2_WAY',
  },
  {
    id: 427887,
    type: 'PHONE',
    subType: null,
    status: 'DEACTIVE',
    phone: {
      number: '559317228',
      type: 'PREPAID',
      numberName: null,
    },
    balance: 0,
    pendingBalance: null,
    subscription: {
      offeringId: '0',
      name: '',
    },
    canGetPackage: false,
    canGetTariff: false,
    eligibleForBonus: false,
    isPrimary: false,
    numberId: 85470,
    numberStatus: 'DEACTIVE',
  },
];

export const cabinetTabsMenu = (incomingObject) => {
  return [
    {
      icon: <Home width={32} height={32} />,
      title: 'cabinet:sidebar.Main',
      visible: true,
    },
    {
      icon: <Tariffs width={32} height={32} />,
      title: 'cabinet:sidebar.Tariffs',
      visible: incomingObject.canGetTariff,
    },
    {
      icon: <Packages width={32} height={32} />,
      title: 'cabinet:sidebar.Packages',
      visible: incomingObject.canGetPackage,
    },
  ];
};
export const cabinetTabsTablet = (incomingObject) => {
  return [
    {
      icon: <HomeTablet width={24} height={24} />,
      title: 'cabinet:sidebar.Main',
      visible: true,
    },
    {
      icon: <TariffsTablet width={24} height={24} />,
      title: 'cabinet:sidebar.Tariffs',
      visible: incomingObject.canGetTariff,
    },
    {
      icon: <PackagesTablet width={24} height={24} />,
      title: 'cabinet:sidebar.Packages',
      visible: incomingObject.canGetPackage,
    },
  ];
};

export const remainingUsage = [
  {
    icon: <CallNew />,
    type: 'VOICE',
  },
  {
    icon: <InternetNew />,
    type: 'INTERNET',
  },
  {
    icon: <SmsNew />,
    type: 'SMS',
  },
];

export const getPercentage = (balance, limit) => {
  if (Number.isNaN(balance / limit)) return 0;

  return (balance / limit) * 100;
};

export const cabinetPackageCategories = [
  { title: 'Internet', value: 'INTERNET' },
  { title: 'SMS', value: 'SMS' },
];

export const cabinetInternetPackageCategories = [
  {
    title: 'common:All',
    value: ['MONTHLY', 'WEEKLY', 'DAILY', 'SOCIAL_MEDIA', 'SPECIAL'],
  },
  { title: 'cabinet:common.Monthly', value: 'MONTHLY' },
  { title: 'cabinet:common.Weekly', value: 'WEEKLY' },
  { title: 'cabinet:common.Daily', value: 'DAILY' },
  { title: 'cabinet:common.Social media', value: 'SOCIAL_MEDIA' },
  { title: 'cabinet:common.Special', value: 'SPECIAL' },
];

export const ONE_WAY_BLOCK = 'BLOCK_1_WAY';
export const TWO_WAY_BLOCK = 'BLOCK_2_WAY';
export const ACTIVE = 'ACTIVE';
export const PRE_ACTIVE = 'PRE_ACTIVE';

export const prePaidBalanceCategories = [
  { title: 'cabinet:home.balance.onNetBonus', value: 'onNetBonus' },
  { title: 'cabinet:home.balance.countryWide', value: 'countrywideBonus' },
  { title: 'cabinet:home.balance.bonusBalance', value: 'mainBalance' },
];

export const postPaidBalanceCategories = [
  'totalPossibleLimit',
  'corporateBalance',
  'corporatePossibleLimit',
  'corporateLimit',
  'individualBalanceTitle',
  'individualPossibleLimit',
  'individualBalance',
  'unpaidIndividualDebt',
];

//   { title: 'cabinet:home.balance.corporateLimit', value: 'corporateLimit' },
//   {
//     title: 'cabinet:home.balance.corporatePossibleLimit',
//     value: 'corporatePossibleLimit',
//   },
//   {
//     title: 'cabinet:home.balance.individualBalance',
//     value: 'individualBalance',
//   },
//   {
//     title: 'cabinet:home.balance.individualPossibleLimit',
//     value: 'individualPossibleLimit',
//   },
//   {
//     title: 'cabinet:home.balance.unpaidIndividualDebt',
//     value: 'unpaidIndividualDebt',
//   },
//   {
//     title: 'cabinet:home.balance.totalPossibleLimit',
//     value: 'totalPossibleLimit',
//   },
// ];
export const dummyPackagesData = [
  {
    id: 14,
    ngbssId: null,
    packageType: 'INTERNET',
    periodType: 'DAY',
    periodTypeValue: 'gün',
    period: 30,
    volumeType: 'MB',
    volumeTypeValue: 'MB',
    volume: '500',
    price: 3,
    currency: 'AZN',
    currencyValue: 'AZN',
    title: null,
    subTitle: null,
    note: null,
    detailedInfo: null,
    social: {
      volume: null,
      volumeType: null,
      iconType: null,
    },
    duration: 'THIRTY_DAYS',
    isOnlyForPostpaid: false,
    dateType: 'ACTIVATION',
    updateType: 'ADD',
    deleteType: 'REMOVE',
    itemTypeValue: null,
    buyAdditionalType: 'NOT_REMOVE',
    confirmation: {
      confirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
      removeConfirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
    },
    filterType: 'MONTHLY',
    renew: true,
    prePaid: true,
    postPaid: true,
  },
  {
    id: 23,
    ngbssId: null,
    packageType: 'SMS',
    periodType: 'DAY',
    periodTypeValue: 'gün',
    period: 30,
    volumeType: 'SMS',
    volumeTypeValue: 'SMS',
    volume: '50',
    price: 0.79,
    currency: 'AZN',
    currencyValue: 'AZN',
    title: null,
    subTitle: null,
    note: null,
    detailedInfo: null,
    social: {
      volume: null,
      volumeType: null,
      iconType: null,
    },
    duration: 'THIRTY_DAYS',
    isOnlyForPostpaid: false,
    dateType: 'ACTIVATION',
    updateType: 'OVERWRITE',
    deleteType: 'REMOVE',
    itemTypeValue: null,
    buyAdditionalType: 'REMOVE',
    confirmation: {
      confirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
      removeConfirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
    },
    filterType: null,
    renew: true,
    prePaid: true,
    postPaid: false,
  },
  {
    id: 15,
    ngbssId: null,
    packageType: 'INTERNET',
    periodType: 'DAY',
    periodTypeValue: 'gün',
    period: 30,
    volumeType: 'GB',
    volumeTypeValue: 'GB',
    volume: '1',
    price: 5,
    currency: 'AZN',
    currencyValue: 'AZN',
    title: null,
    subTitle: null,
    note: null,
    detailedInfo: null,
    social: {
      volume: null,
      volumeType: null,
      iconType: null,
    },
    duration: 'THIRTY_DAYS',
    isOnlyForPostpaid: false,
    dateType: 'ACTIVATION',
    updateType: 'ADD',
    deleteType: 'REMOVE',
    itemTypeValue: null,
    buyAdditionalType: 'NOT_REMOVE',
    confirmation: {
      confirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
      removeConfirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
    },
    filterType: 'MONTHLY',
    renew: true,
    prePaid: true,
    postPaid: true,
  },
  {
    id: 24,
    ngbssId: null,
    packageType: 'SMS',
    periodType: 'DAY',
    periodTypeValue: 'gün',
    period: 30,
    volumeType: 'SMS',
    volumeTypeValue: 'SMS',
    volume: '150',
    price: 1.99,
    currency: 'AZN',
    currencyValue: 'AZN',
    title: null,
    subTitle: null,
    note: null,
    detailedInfo: null,
    social: {
      volume: null,
      volumeType: null,
      iconType: null,
    },
    duration: 'THIRTY_DAYS',
    isOnlyForPostpaid: false,
    dateType: 'ACTIVATION',
    updateType: 'OVERWRITE',
    deleteType: 'REMOVE',
    itemTypeValue: null,
    buyAdditionalType: 'REMOVE',
    confirmation: {
      confirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
      removeConfirmationText:
        'Paketlərdən yararlana bilməyiniz üçün hesabınıza daxil olmağınız xahiş olunur (giriş ekranına yönləndiriləcəksiniz)',
    },
    filterType: null,
    renew: true,
    prePaid: true,
    postPaid: true,
  },
];

export const dummyDataTariffs = [
  {
    title: 'ILK',
    description: 'Yeni abunəçilərin sadə tarifi!',
    price: '0',
    period: 'Monthly',
    isMine: false,
    status: 0,
    link: '',
    includes: [
      {
        amount: '0.05',
        for: '₼/min',
        usage: 'On-net',
      },
      {
        amount: '0.06',
        for: '₼/min',
        usage: 'Off-net',
      },
    ],
  },
  {
    title: 'ILK',
    description: 'Yeni abunəçilərin sadə tarifi!',
    price: '0',
    period: 'Monthly',
    isMine: false,
    status: 0,
    link: '',
    includes: [
      {
        amount: '0.05',
        for: '₼/min',
        usage: 'On-net',
      },
      {
        amount: '0.06',
        for: '₼/min',
        usage: 'Off-net',
      },
    ],
  },
  {
    title: 'ƏlaSAAT',
    description: 'Cəmi 8 qəpiyə 1 saat danışıq!',
    price: '0',
    period: 'Monthly',
    isMine: true,
    status: 0,
    link: '',
    includes: [
      {
        amount: '0.08',
        for: '₼/min',
        usage: 'On-net',
      },
      {
        amount: '0.14',
        for: '₼/min',
        usage: 'Off-net',
      },
    ],
  },
  {
    title: 'ƏlaSAAT',
    description: 'Cəmi 8 qəpiyə 1 saat danışıq!',
    price: '0',
    period: 'Monthly',
    isMine: true,
    status: 0,
    link: '',
    includes: [
      {
        amount: '0.08',
        for: '₼/min',
        usage: 'On-net',
      },
      {
        amount: '0.14',
        for: '₼/min',
        usage: 'Off-net',
      },
    ],
  },
];

export const statusInfoMap = {
  DEACTIVE: {
    text: 'accounts.LoggedOut',
    icon: <SimIcon width={24} height={24} />,
    class: 'disabled',
  },
  BLOCK_1_WAY: {
    text: 'accounts.BlockedOneWay',
    icon: <SimIcon width={24} height={24} />,
    class: 'warning',
  },
  BLOCK_2_WAY: {
    text: 'accounts.BlockedTwoWays',
    icon: <SimIcon width={24} height={24} />,
    class: 'error',
  },
  ACTIVE: {
    text: 'accounts.Active',
    icon: <SimIcon width={24} height={24} />,
    class: 'active',
  },
  PRE_ACTIVE: {
    text: 'accounts.BlockedTwoWays',
    icon: <SimIcon width={24} height={24} />,
    class: 'error',
  },
};
